import React, { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

type BaseModalProps = {
  Header?: ReactNode;
  SupportText?: ReactNode;
  Content?: ReactNode;
  Footer?: ReactNode;
  className?: string;
};

/**
 * Base modal is the absolute bare bones of modals for the [new design kernel](https://www.figma.com/file/yanlFLKIrkKo4aPtIT7LBV/Kernel-Design-System?node-id=167%3A3660&mode=dev)
 *   - Pretty much only sets background color, dimensions, and margins
 */
const BaseModal: React.FC<BaseModalProps> = ({
  Header = undefined,
  SupportText = undefined,
  Content = undefined,
  Footer = undefined,
  className = '',
}: BaseModalProps) => {
  return (
    <div
      className={twMerge(
        'flex max-h-[100vh] max-w-[640px] flex-col gap-y-4 overflow-auto bg-white p-6',
        className
      )}
    >
      {Header}
      {SupportText}
      {Content}
      {Footer}
    </div>
  );
};

export default BaseModal;
